var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBadge = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 319.7 421.8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l.2 271.2a106.2 106.2 0 001.1 15.9 89.6 89.6 0 006.9 24.6c10.1 22.4 22 35.7 33.4 47 22.8 22.8 45.6 34.3 61.2 42.1a287.6 287.6 0 0057 21 286.4 286.4 0 0057.1-21c15.6-7.8 38.4-19.3 61.2-42.1 11.4-11.3 23.3-24.6 33.4-47a89.6 89.6 0 006.9-24.6 106.2 106.2 0 001.1-15.9L319.7 0zm290.4 29.3v80.1h-261V29.3zm-.1 178.6a163.3 163.3 0 00-22.1-5c-4.7-.7-23.5-3.5-50.1-.3-11.8 1.4-22.5 4-43.7 9.3-15.6 3.9-28.4 7.5-37.4 10.1-19.4 6.8-51.3 14.5-87.6 6.4a147.5 147.5 0 01-20-5.9v-83.8h260.9zm-83.8 165.8a227 227 0 01-46.7 17.1 228 228 0 01-46.6-17.1l-8.6-4.4 55.1-31.8 55.3 31.9zm83.7-104.9a78.7 78.7 0 01-.4 8.4 75.3 75.3 0 01-6.1 23.7c-8.2 18.4-18 29.2-27.3 38.4a155.8 155.8 0 01-13.2 11.9l-1.3-.8-82.2-47.4-82.1 47.4-1.2.7a172.2 172.2 0 01-13.1-11.8c-9.3-9.2-19.1-20-27.3-38.4a75.3 75.3 0 01-6.1-23.7 78.7 78.7 0 01-.4-8.4V253a159.6 159.6 0 0021.8 4.9c4.6.7 23.5 3.5 50.1.3 11.8-1.4 22.4-4.1 43.7-9.3 15.6-3.9 28.4-7.5 37.4-10.1 19.4-6.8 51.2-14.5 87.6-6.4a144.7 144.7 0 0120.1 6z",
    fill: "#fd3713"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBadge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/badge.9aedb73b.svg";
export { ForwardRef as ReactComponent };